import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzOffer275 } from './pages'

type TIdToPageMapWoofzOffer275 = Record<PageIdWoofzOffer275, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_OFFER2_75: TIdToPageMapWoofzOffer275 = {
  [PageIdWoofzOffer275.SUBSCRIPTIONS_OFFER2_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/subscriptions/SubscriptionsOffer275'
      ).then((m) => ({
        default: m.SubscriptionsOffer275,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/subscriptions/SubscriptionsOffer275'
      ),
  },
  [PageIdWoofzOffer275.CHAT_UPSELL_OFFER2_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageIdWoofzOffer275.UPSELL_OFFER2_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_offer/woofz_offer2_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzOffer275.DOWNLOAD_OFFER2_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_offer/woofz_offer2_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzOffer275.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
